<div class="page-layout">
  <!-- Sidebar -->
  <app-sidebar></app-sidebar>

  <!-- Main Content -->
  <main class="main-content">
    <!-- Page Header -->
    <header class="page-header">
      <h1 class="page-title">Trainees</h1>
    </header>

    <!-- Content Card -->
    <div class="content-card">
      <!-- Table Header -->
      <div class="table-header">
        <div class="table-title-section">
          <h2 class="table-title">Trainees list</h2>
          <span class="badge badge-blue">{{trainees.length}}</span>
        </div>
        <div class="search-box">
          <svg viewBox="0 0 24 24" class="search-icon">
            <path fill="currentColor" d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
          </svg>
          <input
            type="text"
            placeholder="Search"
            class="search-input"
            [(ngModel)]="searchQuery"
            (input)="onSearch()"
          />
        </div>
      </div>

      <!-- Table -->
      <div class="table-container">
        <table class="data-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Phone</th>
              <th>Type</th>
              <th>Parent</th>
              <th>Status</th>
              <th>Joined</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="isLoading">
              <td colspan="6" style="text-align: center; padding: 2rem;">
                Loading trainees...
              </td>
            </tr>
            <tr *ngIf="!isLoading && paginatedTrainees.length === 0">
              <td colspan="6" style="text-align: center; padding: 2rem;">
                No trainees found.
              </td>
            </tr>
            <tr *ngFor="let trainee of paginatedTrainees" class="table-row">
              <td>
                <div class="trainer-info">
                  <div class="trainer-avatar">
                    <img [src]="getAvatar(trainee.name)" [alt]="trainee.name"/>
                  </div>
                  <div class="trainer-details">
                    <div class="trainer-name">{{trainee.name}}</div>
                    <div class="trainer-email" *ngIf="trainee.email">{{trainee.email}}</div>
                  </div>
                </div>
              </td>
              <td>
                <span class="phone-text">{{trainee.phoneNumber || '—'}}</span>
              </td>
              <td>
                <span class="type-badge" [class.sub-user]="trainee.isSubUser">
                  {{trainee.isSubUser ? 'Sub-user' : 'User'}}
                </span>
              </td>
              <td>
                <span class="parent-text">{{trainee.parentName || '—'}}</span>
              </td>
              <td>
                <span class="level-badge" [class.verified]="trainee.isPhoneVerified" [class.unverified]="!trainee.isPhoneVerified">
                  {{trainee.isSubUser ? '—' : (trainee.isPhoneVerified ? 'Verified' : 'Unverified')}}
                </span>
              </td>
              <td>
                <span class="salary-text">{{trainee.createdAt | date: 'MMM d, y'}}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="pagination-container" *ngIf="totalPages > 1">
        <button
          class="pagination-btn"
          (click)="previousPage()"
          [disabled]="currentPage === 1"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
          Previous
        </button>

        <div class="pagination-pages">
          <ng-container *ngFor="let page of getPageNumbers()">
            <button
              *ngIf="page !== '...'"
              class="pagination-page"
              [class.active]="page === currentPage"
              (click)="goToPage($any(page))"
            >
              {{ page }}
            </button>
            <span *ngIf="page === '...'" class="pagination-ellipsis">...</span>
          </ng-container>
        </div>

        <button
          class="pagination-btn"
          (click)="nextPage()"
          [disabled]="currentPage === totalPages"
        >
          Next
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </button>
      </div>
    </div>
  </main>
</div>
